/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Action, Selector, State } from '@ngxs/store';
import { RedlineMarkupConfiguration, RedlineMarkupStateModel } from './redlineMarkup.model';
import { LoadRedlineMarkupConfig, MergeRedlineFeatures, SetCurrentRedlineMarkupLayer } from './redlineMarkup.actions';
import { DashGisUtil } from '../../../modules/shared/dash-gis-util';
import { tap } from 'rxjs/operators';
import { RestService } from '../../../modules/shared/services/rest.service';
import { RedlineState } from '../../redline/state/redline.state';
import { RedlineStateModel } from '../../redline/state/redline.model';
import { Injectable } from '@angular/core';

@State<RedlineMarkupStateModel>({
    name: 'redlineMarkup',
    defaults: {
        currentLayer: '',
        layers: [],
    },
})
@Injectable()
export class RedlineMarkupState {
    @Action(LoadRedlineMarkupConfig)
    loadRedlineMarkupConfig({ getState, setState }, action: LoadRedlineMarkupConfig) {
        const route = `map/mark/config/${action.mapName}`;
        return this.rest.apiGet<RedlineMarkupConfiguration>(route).pipe(
            tap((config: RedlineMarkupConfiguration) => {
                if (config) {
                    const state: RedlineMarkupStateModel = DashGisUtil.clone(getState());
                    state.layers = config.layers;
                    setState(state);
                }
            })
        );
    }

    @Action(SetCurrentRedlineMarkupLayer)
    setCurrentRedlineLayer({ getState, setState }, action: SetCurrentRedlineMarkupLayer) {
        const newState: RedlineMarkupStateModel = DashGisUtil.clone(getState());
        newState.currentLayer = action.layer;
        setState(newState);
    }

    @Action(MergeRedlineFeatures)
    mergeFeatures() {
        // future improvement/implementation
    }

    @Selector()
    static currentLayer(state: RedlineMarkupStateModel) {
        return state.currentLayer;
    }

    @Selector()
    static layers(state: RedlineMarkupStateModel) {
        return state.layers;
    }

    @Selector()
    static currentConfig(state: RedlineMarkupStateModel) {
        if (state.currentLayer) {
            return state.layers.find((l) => l.name === state.currentLayer);
        }
    }

    @Selector([RedlineState])
    static editableLayers(state: RedlineMarkupStateModel, redlineState: RedlineStateModel) {
        return state.layers.filter(
            (markupLayer) =>
                redlineState.edit.findIndex((editable) =>
                    editable.name === markupLayer.redlineLayerName) !== -1
        );
    }

    constructor(private rest: RestService) {}
}
